import WalletOperationsTable from './WalletOperationsTable';

export default WalletOperationsTable;
